module.exports = __webpack_public_path__ + "img/table1-en.19e59246.svg";